import React, { useState } from 'react';
import { Button, Icon } from '@iq/react-components';

import { DND_OPTIONS, setDoNotDisturb } from '../../../bundles/notifications/doNotDisturb';

const DoNotDisturbPanel = ({ onBack, siteId }) => {
  const [selectedDuration, setSelectedDuration] = useState(null);

  const handleMute = () => {
    if (selectedDuration) {
      setDoNotDisturb(selectedDuration, siteId);
      onBack();
    }
  };

  return (
    <div className="do-not-disturb-overlay">
      <div className="do-not-disturb-panel">
        <div className="do-not-disturb-panel--header">
          <span>Do not disturb</span>
          <Icon
            icon="he-close"
            size="xs"
            onClick={onBack}
          />
        </div>

        <div className="do-not-disturb-panel--body">
          <p className="do-not-disturb-panel--description">Mute all pop-up notifications:</p>
          <div className="do-not-disturb-panel--options">
            {DND_OPTIONS.map((option) => (
              <label
                key={option.value}
                className="do-not-disturb-panel--option"
              >
                <input
                  type="radio"
                  name="dnd-duration"
                  value={option.value}
                  checked={selectedDuration === option.value}
                  onChange={() => setSelectedDuration(option.value)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="do-not-disturb-panel--footer">
          <Button
            activity="secondary"
            onClick={onBack}
          >
            Back
          </Button>
          <Button
            activity="primary"
            onClick={handleMute}
            disabled={!selectedDuration}
          >
            Mute
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DoNotDisturbPanel;
